"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterButton = exports.Content = void 0;
var _mui = require("@ori-ui/mui");
const FilterButton = exports.FilterButton = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        cursor: 'pointer',
        userSelect: 'none',
        width: 'fit-content',
        gap: theme.spacing(1),
        alignItems: 'center'
    };
});
const Content = exports.Content = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    };
});
